module.exports = __webpack_public_path__ + "media/images/quizTypeGray-a49199456cdf554335c9fa03143e5ac5.svg";